module.exports = __webpack_public_path__ + "static/img/lgny-details.49cefc1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/lgny-details.png
// module id = Ds4O
// module chunks = 0